




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import vue from 'vue';
import { colors } from '@/config';

More(Highcharts);

@Component({components: {Chart}})
export default class ProfitLoss extends Vue {
    @Prop() readonly profitloss!: any;
    @Prop() dark!: boolean;

    chartOptions: any = {
        chart: {
            type: 'waterfall',
            backgroundColor: 'transparent',
        },

        credits: {
            enabled: false,
        },

        title: {
            text: '',
        },


        xAxis: {
            type: 'category',
            labels: {
                autoRotation: [0],
                // rotation: [-25],
                staggerLines: 1,
                padding: 10,
                style: {
                    fontSize: '1rem',
                    textOverflow: 'none',
                    whiteSpace: 'normal',
                    color: this.dark ? colors.Light : colors.Black,
                },
            },
            plotLines: [{
                color: this.dark ? colors.LightGrey : colors.DarkGrey,
                dashStyle: 'dot',
                value: 1.5,
                width: 2,
                label: {
                    text: Vue.prototype.$t('Bruttoresultat'),
                    style: {
                        fontSize: '0.875rem',
                        color: this.dark ? colors.Light : colors.DarkGrey,
                    },
                },
            },
            {
                color: this.dark ? colors.LightGrey : colors.DarkGrey,
                dashStyle: 'dot',
                value: 3.5,
                width: 2,
                label: {
                    text: Vue.prototype.$t('Rörelseresultat'),
                    style: {
                        fontSize: '0.875rem',
                        color: this.dark ? colors.Light : colors.DarkGrey,
                    },
                },
            }],
            lineColor: this.dark ? colors.Black : colors.LightGrey,
        },

        yAxis: {
            title: {
                text: '',
            },
            labels: {
                style: {
                    fontSize: this.dark ? '1.25rem' : '1rem',
                    color: this.dark ? colors.Light : colors.Black,
                },
                formatter() { return (vue as any).options.filters.KR((this as any).value); },
            },
            tickPixelInterval: this.dark ? 250 : 150,
            gridLineColor: this.dark ? colors.Black : colors.LightGrey,
            plotLines: [{
                color: colors.Black,
                width: this.dark ? 3 : 2,
                value: 0,
                zIndex: 2,
            }],
        },

        legend: {
            enabled: false,
        },

        tooltip: {
            headerFormat: '',
            pointFormat: '<span>{point.subname}: <b>{point.y:,.0f} tkr</b></span>',
            style: {
                fontSize: '1.25rem',
                color: this.dark ? colors.Light : colors.Black,
            },
            backgroundColor: this.dark ? colors.Dark : colors.Light,
        },

        series: [],
    };

    mounted() {
        if (this.profitloss) {
            this.chartOptions.series = this.getSeries();
        }
    }

    @Watch('profitloss', { immediate: true, deep: true })
    profitlossChanged() {
        if (this.profitloss) {
            this.chartOptions.series = this.getSeries();
        }
    }

    getSeries() {
        return [{
            upColor: colors.DarkGrey,
            color: colors.Tertiary,
            lineColor: this.dark ? colors.Black : colors.DarkGrey,
            borderColor: this.dark ? colors.Black : colors.DarkGrey,
            data: [{
                name: Vue.prototype.$t('Intäkter'),
                subname: Vue.prototype.$t('Nettoomsättning'),
                y: this.profitloss.A,
                color: this.dark ? colors.Secondary : colors.Primary,
            }, {
                name: Vue.prototype.$t('Intäkter'),
                subname: Vue.prototype.$t('Övriga rörelseintäkter'),
                y: this.profitloss.B,
            }, {
                name: Vue.prototype.$t('Varor & material'),
                subname: Vue.prototype.$t('Kostnader för varor & material'),
                y: this.profitloss.D,
            }, {
                name: Vue.prototype.$t('Drifts-kostnader'),
                subname: Vue.prototype.$t('Övriga externa kostnader'),
                y: this.profitloss.F,
            }, {
                name: Vue.prototype.$t('Drifts-kostnader'),
                subname: Vue.prototype.$t('Personalkostnader'),
                y: this.profitloss.G,
            }, {
                name: Vue.prototype.$t('Drifts-kostnader'),
                subname: Vue.prototype.$t('Övriga rörelsekostnader'),
                y: this.profitloss.H,
            }, {
                name: Vue.prototype.$t('Av- och ned-skrivningar'),
                subname: Vue.prototype.$t('Av- och nedskrivningar'),
                y: this.profitloss.J,
            }, {
                name: Vue.prototype.$t('Finansiella poster'),
                subname: Vue.prototype.$t('Finansiella poster'),
                y: this.profitloss.L + this.profitloss.M,
                color: this.profitloss.L + this.profitloss.M > 0 ? colors.DarkGrey : colors.LightGrey,
            }, {
                name: Vue.prototype.$t('Boksluts-disp.'),
                subname: Vue.prototype.$t('Bokslutsdispositioner'),
                y: this.profitloss.O,
                color: this.profitloss.O > 0 ? colors.DarkGrey : colors.LightGrey,
            }, {
                name: Vue.prototype.$t('Skatt'),
                subname: Vue.prototype.$t('Årets skatt'),
                y: this.profitloss.Q,
                color: this.profitloss.Q > 0 ? colors.DarkGrey : colors.LightGrey,
            }, {
                name: Vue.prototype.$t('Årets resultat'),
                subname: Vue.prototype.$t('Årets resultat'),
                isSum: true,
                color: this.profitloss.R > 0 ? colors.Positive : colors.Negative,
            },
            ],

            pointPadding: 0,
        }];
    }
}
